@if (getPrizeBreakdown$ | async; as prizeBreakdown) {
  <ion-content (click)="touch()">
    <app-thumbnail-animation></app-thumbnail-animation>
    <div class="page-background-blue">
      <ion-grid class="ion-no-padding">
        <div class="title-padding title-section">
          <ion-row>
            <div class="display-block">
              <!-- <span><img src="../../../../assets/icon/information.svg" /></span> -->
              <span style="float: right" (click)="backTpSyndicate()">
                <img src="../../../../assets/icon/closex.svg" alt="Close button" />
              </span>
            </div>
            <div class="display-block">
              <h1 class="header-text heading-legal">{{ "breakdown.Breakdown" | translate }}</h1>
              <h1 class="txt-clr-light-blue sub-title">
                {{ "breakdown.Check date" | translate }} •
                {{ getClaimCheckDate(prizeBreakdown?.check_period_start) | date : "dMMM" }} -
                {{ getClaimCheckDate(prizeBreakdown?.check_period_end) | date : "d MMM" }}
              </h1>
            </div>
          </ion-row>
        </div>
        <div class="winning-details page-padding">
          <p class="check-time">{{ "breakdown.won" | translate }}</p>
          @if (
            prizeBreakdown?.preferred_currency?.total_bonus_credit
            ? prizeBreakdown?.preferred_currency?.total_bonus_credit
            : prizeBreakdown?.total_bonus_credit
            ) {
            <mat-accordion class="for-align">
              <mat-expansion-panel class="acc-change" (opened)="panelOpenState1 = true" (closed)="panelOpenState1 = false"
                hideToggle="true">
                <mat-expansion-panel-header class="heading" [ngClass]="{ 'bottom-border': !panelOpenState1 }">
                  <mat-panel-title class="small">
                    <img class="cash-winning-blue-img" src="../../../../assets/icon/CreditWalletPink.svg" alt="" />
                    <h6>{{ "breakdown.Credit" | translate }}</h6>
                  </mat-panel-title>
                  <mat-panel-title class="amount">
                    {{ currencySymbol
                    }}{{
                    (prizeBreakdown?.preferred_currency?.total_bonus_credit
                    ? prizeBreakdown?.preferred_currency?.total_bonus_credit
                    : prizeBreakdown?.total_bonus_credit
                    ) | displayCurrency
                    }}
                  </mat-panel-title>
                  @if (!panelOpenState1) {
                    <ion-icon name="chevron-forward-outline"></ion-icon>
                  }
                  @if (panelOpenState1) {
                    <ion-icon name="chevron-down-outline"></ion-icon>
                  }
                </mat-expansion-panel-header>
                <div class="expand-content">
                  <p class="content" [innerHTML]="'breakdown.use_credit' | translate"></p>
                  <button class="check-btn" (click)="navigateToStore()">{{ "breakdown.view_credit" | translate}}</button>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          }
          @if (getCreditWonAmount(prizeBreakdown) > 0)
            {
              <mat-accordion class="for-align">
                <mat-expansion-panel
                  class="acc-change"
                  (opened)="panelOpenState1 = true"
                  (closed)="panelOpenState1 = false"
                  hideToggle="true"
                >
                  <mat-expansion-panel-header
                    class="heading"
                    [ngClass]="{ 'bottom-border': !panelOpenState1 }"
                  >
                    <mat-panel-title class="small">
                      <img
                        class="cash-winning-blue-img"
                        src="../../../../assets/icon/CreditWalletPink.svg"
                        alt=""
                      />
                      <h6>{{ "breakdown.total_credit" | translate }}</h6>
                    </mat-panel-title>
                    <mat-panel-title class="amount">
                      {{ currencySymbol }}{{ getCreditWonAmount(prizeBreakdown) | displayCurrency }}
                    </mat-panel-title>

                    <ion-icon
                      [name]="panelOpenState1 ? 'chevron-down-outline' : 'chevron-forward-outline'"
                    ></ion-icon>
                  </mat-expansion-panel-header>
                  <div class="expand-content">
                    <p class="content" [innerHTML]="'breakdown.use_credit' | translate"></p>

                  @if (creditBreakdown?.length) {
                      <div class="list-row" [ngClass]="{ 'single-li': creditBreakdown?.length === 1 }">
                        <ul>
                          @for (item of creditBreakdown; track item) {
                              <li>
                                <div class="tc-title">{{ item?.label | translate }}</div>
                                <div class="tc-ammount">{{ item?.value }}</div>
                              </li>
                            }
                        </ul>
                      </div>
                    }

                    <button class="check-btn" (click)="navigateToStore()">
                      {{ "breakdown.view_credit" | translate }}
                    </button>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            }
          @if (
            prizeBreakdown?.preferred_currency?.total_cash_winnings
            ? prizeBreakdown?.preferred_currency?.total_cash_winnings
            : prizeBreakdown?.total_cash_winnings
            ) {
            <mat-accordion>
              <mat-expansion-panel class="" (opened)="panelOpenState2 = true" (closed)="panelOpenState2 = false"
                hideToggle="true">
                <mat-expansion-panel-header class="heading" [ngClass]="{ 'bottom-border': !panelOpenState2 }">
                  <mat-panel-title class="small">
                    <img class="cash-winning-blue-img" src="../../../../assets/icon/CashIcon.png" alt="" />
                    <h6>{{ "breakdown.Cash" | translate }}</h6>
                  </mat-panel-title>
                  <mat-panel-title class="amount">
                    {{ currencySymbol
                    }}{{
                    (prizeBreakdown?.preferred_currency?.total_cash_winnings
                    ? prizeBreakdown?.preferred_currency?.total_cash_winnings
                    : prizeBreakdown?.total_cash_winnings
                    ) | displayCurrency
                    }}
                  </mat-panel-title>
                  @if (!panelOpenState2) {
                    <ion-icon name="chevron-forward-outline"></ion-icon>
                  }
                  @if (panelOpenState2) {
                    <ion-icon name="chevron-down-outline"></ion-icon>
                  }
                </mat-expansion-panel-header>
                <div class="expand-content">
                  <p class="cash-content" [innerHTML]="'breakdown.view_cash_out' | translate"></p>
                  <button class="check-btn" (click)="navigateToCashout()">{{ "breakdown.cash_out" | translate }}</button>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          }
          @if ((prizeBreakdown?.preferred_currency?.cash_won_sum ?
            prizeBreakdown?.preferred_currency?.cash_won_sum : prizeBreakdown?.cash_won_sum) &&
            (prizeBreakdown?.preferred_currency?.cash_won_sum ? prizeBreakdown?.preferred_currency?.cash_won_sum :
            prizeBreakdown?.cash_won_sum)> 0) {
            <mat-accordion>
              <mat-expansion-panel class="" (opened)="panelOpenState2 = true" (closed)="panelOpenState2 = false"
                hideToggle="true">
                <mat-expansion-panel-header class="heading" [ngClass]="{ 'bottom-border': !panelOpenState2 }">
                  <mat-panel-title class="small">
                    <img class="cash-winning-blue-img" src="../../../../assets/icon/CashIcon.png" alt="" />
                    <h6>{{ "breakdown.winnings" | translate }}</h6>
                  </mat-panel-title>
                  <mat-panel-title class="amount">
                    {{ currencySymbol
                    }}{{
                    (prizeBreakdown?.preferred_currency?.cash_won_sum
                    ? prizeBreakdown?.preferred_currency?.cash_won_sum
                    : prizeBreakdown?.cash_won_sum
                    ) | displayCurrency
                    }}
                  </mat-panel-title>
                  @if (!panelOpenState2) {
                    <ion-icon name="chevron-forward-outline"></ion-icon>
                  }
                  @if (panelOpenState2) {
                    <ion-icon name="chevron-down-outline"></ion-icon>
                  }
                </mat-expansion-panel-header>
                <div class="expand-content">
                  <p class="cash-content" [innerHTML]="'breakdown.view_cash_out' | translate"></p>
                  <button class="check-btn" (click)="navigateToCashout()">{{ "breakdown.cash_out" | translate }}</button>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          }
          @if (prizeBreakdown?.total_reward_points) {
            <mat-accordion>
              <mat-expansion-panel (opened)="panelOpenState3 = true" (closed)="panelOpenState3 = false" hideToggle="true">
                <mat-expansion-panel-header class="heading" [ngClass]="{ 'bottom-border': !panelOpenState3 }">
                  <mat-panel-title class="small">
                    <img class="cash-winning-blue-img" src="../../../../assets/icon/breakcoin.svg" alt="" />
                    <h6>{{ "breakdown.Points" | translate }}</h6>
                  </mat-panel-title>
                  <mat-panel-title class="amount">
                    {{ prizeBreakdown?.total_reward_points | number : "1.2-2" }}
                  </mat-panel-title>
                  @if (!panelOpenState3) {
                    <ion-icon name="chevron-forward-outline"></ion-icon>
                  }
                  @if (panelOpenState3) {
                    <ion-icon name="chevron-down-outline"></ion-icon>
                  }
                </mat-expansion-panel-header>
                <div class="expand-content">
                  <p class="content" [innerHTML]="use_points"></p>
                  <button class="check-btn" (click)="navigateToGames()">{{ "breakdown.play_games" | translate}}</button>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          }
          @if (prizeBreakdown?.points_won_sum && prizeBreakdown?.points_won_sum > 0) {
            <mat-accordion>
              <mat-expansion-panel (opened)="panelOpenState3 = true" (closed)="panelOpenState3 = false" hideToggle="true">
                <mat-expansion-panel-header class="heading" [ngClass]="{ 'bottom-border': !panelOpenState3 }">
                  <mat-panel-title class="small">
                    <img class="cash-winning-blue-img" src="../../../../assets/icon/breakcoin.svg" alt="" />
                    <h6>{{ "breakdown.Points" | translate }}</h6>
                  </mat-panel-title>
                  <mat-panel-title class="amount">
                    {{ prizeBreakdown?.points_won_sum | number : "1.0-0" }}
                  </mat-panel-title>
                  @if (!panelOpenState3) {
                    <ion-icon name="chevron-forward-outline"></ion-icon>
                  }
                  @if (panelOpenState3) {
                    <ion-icon name="chevron-down-outline"></ion-icon>
                  }
                </mat-expansion-panel-header>
                <div class="expand-content">
                  <p class="content" [innerHTML]="use_points"></p>
                  <button class="check-btn" (click)="navigateToGames()">{{ "breakdown.play_games" | translate}}</button>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          }
          <mat-accordion>
            @if (prizeBreakdown?.lucky_numbers?.prize_draw_entries > 0) {
              <mat-expansion-panel (opened)="panelOpenState5 = true" (closed)="panelOpenState5 = false" hideToggle="true"
                >
                <mat-expansion-panel-header class="heading" [ngClass]="{ 'bottom-border': !panelOpenState5 }">
                  <mat-panel-title class="small">
                    <img class="cash-winning-blue-img" src="../../../../assets/icon/breakkay.svg" alt="" />
                    <h6>{{ prizeDrawEntries }}</h6>
                  </mat-panel-title>
                  <mat-panel-title class="amount">
                    x{{ prizeBreakdown?.lucky_numbers?.prize_draw_entries }}
                  </mat-panel-title>
                  @if (!panelOpenState5) {
                    <ion-icon name="chevron-forward-outline"></ion-icon>
                  }
                  @if (panelOpenState5) {
                    <ion-icon name="chevron-down-outline"></ion-icon>
                  }
                </mat-expansion-panel-header>
                <div class="expand-content">
                  <p class="content" [innerHTML]="prize_account$ | async "></p>
                  <button class="check-btn" (click)="navigateToPrizeDraw()">{{ "breakdown.view_gift" | translate }}</button>
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
          <mat-accordion>
            @if (prizeBreakdown?.lucky_numbers?.replenished) {
              <mat-expansion-panel (opened)="panelOpenState6 = true" (closed)="panelOpenState6 = false" hideToggle="true"
                >
                <mat-expansion-panel-header class="heading" [ngClass]="{ 'bottom-border': !panelOpenState6 }">
                  <mat-panel-title class="small">
                    <img class="cash-winning-blue-img" src="../../../../assets/icon/breakcycle1.svg" alt="" />
                    <h6>{{ replenished }}</h6>
                  </mat-panel-title>
                  <mat-panel-title class="amount"> x{{ prizeBreakdown?.lucky_numbers?.replenished }} </mat-panel-title>
                  @if (!panelOpenState6) {
                    <ion-icon name="chevron-forward-outline"></ion-icon>
                  }
                  @if (panelOpenState6) {
                    <ion-icon name="chevron-down-outline"></ion-icon>
                  }
                </mat-expansion-panel-header>
                <p class="content" (click)="backTpSyndicate()">{{ replenishedDesc }}</p>
              </mat-expansion-panel>
            }
          </mat-accordion>
          @if (showGoldRings) {
            <mat-accordion>
              <mat-expansion-panel (opened)="panelOpenState7 = true" (closed)="panelOpenState7 = false" hideToggle="true">
                <mat-expansion-panel-header class="heading" [ngClass]="{ 'bottom-border': !panelOpenState7 }">
                  <mat-panel-title class="small">
                    <img class="cash-winning-blue-img" src="../../../../assets/icon/breakup.svg" alt="" />
                    <h6>{{ "breakdown.gold_rings_boosted" | translate }}</h6>
                  </mat-panel-title>
                  <mat-panel-title class="amount"> x1 </mat-panel-title>
                  @if (!panelOpenState7) {
                    <ion-icon name="chevron-forward-outline"></ion-icon>
                  }
                  @if (panelOpenState7) {
                    <ion-icon name="chevron-down-outline"></ion-icon>
                  }
                </mat-expansion-panel-header>
                <p class="content"></p>
              </mat-expansion-panel>
            </mat-accordion>
          }
          @if (showGoldRings) {
            <mat-accordion>
              <mat-expansion-panel (opened)="panelOpenState8 = true" (closed)="panelOpenState8 = false" hideToggle="true">
                <mat-expansion-panel-header class="heading" [ngClass]="{ 'bottom-border': !panelOpenState8 }">
                  <mat-panel-title class="small">
                    <img class="cash-winning-blue-img" src="../../../../assets/icon/breakcycle.svg" alt="" />
                    <h6>{{ "breakdown.gold_rings_replenished" | translate }}</h6>
                  </mat-panel-title>
                  <mat-panel-title class="amount"> x2 </mat-panel-title>
                  @if (!panelOpenState8) {
                    <ion-icon name="chevron-forward-outline"></ion-icon>
                  }
                  @if (panelOpenState8) {
                    <ion-icon name="chevron-down-outline"></ion-icon>
                  }
                </mat-expansion-panel-header>
                <p class="content"></p>
              </mat-expansion-panel>
            </mat-accordion>
          }
          @if (prizeBreakdown?.voucher && encrClaimEventId) {
            <app-voucher-collection [voucher]="prizeBreakdown?.voucher" [breakdownId]="encrClaimEventId" (voucherClaimed)="onVoucherClaimed()"></app-voucher-collection>
          }
        </div>
        <ion-row class="for-align">
          <div class="inline-calender">
            <ion-grid class="ion-no-padding calendar-grid">
              <div class="cal-hint-sec">
                <h1 class="calender-hint">
                  {{ "breakdown.calendar_title" | translate }}
                </h1>
              </div>
              <ion-row>
                <!--Days Row-->
                @for (weekday of weekdays; track weekday) {
                  <ion-col class="ion-no-padding">
                    <h1 class="day-names txt-clr-light-blue">{{ weekday }}</h1>
                  </ion-col>
                }
              </ion-row>
              @for (calenders of newCalendarDays; track calenders) {
                <ion-row class="rows-of-calender">
                  @for (dateDetails of calenders; track dateDetails) {
<ion-col class="ion-no-padding" [ngClass]="[
                  isStartDate(dateDetails.date) && dateDetails.visibility
                    ? isFirstDateWinningDate(dateDetails.date, prizeBreakdown?.checked_ticket_dates)
                      ? 'start-date-gradient'
                      : 'non-winning-start-date-gradient'
                    : isEndDate(dateDetails.date) && dateDetails.visibility
                    ? isLastDateWinningDate(dateDetails.date, prizeBreakdown?.checked_ticket_dates)
                      ? 'end-date-gradient'
                      : 'non-winning-end-date-gradient'
                    : !dateDetails.visibility
                    ? 'invisibleDate'
                    : '',
                  checkWinningDateInDateRange(dateDetails.date, prizeBreakdown?.checked_ticket_dates)
                    ? 'winning-date-visiblity'
                    : ''
                ]">
                      @if (isWinningDate(dateDetails.date, prizeBreakdown?.checked_ticket_dates)) {
<div [ngClass]="
                    isWinningDate(dateDetails.date, prizeBreakdown?.checked_ticket_dates) && dateDetails.visibility
                      ? 'winning-dates'
                      : ''
                  ">
                          @if (dateDetails.visibility) {
                            <h1
                              (click)="openCheckedTickets(dateDetails, prizeBreakdown?.checked_ticket_dates)"
                              class="day-date-numbers in-range-number">
                              {{ dateDetails.date | date : "d" }}
                            </h1>
                          }
                        </div>
                      }
                      @if (!isWinningDate(dateDetails.date, prizeBreakdown?.checked_ticket_dates)) {
                        <div>
                          @if (dateDetails.visibility) {
<h1 class="day-date-numbers" [ngClass]="
                      isInVisibleDate(dateDetails.date)
                        ? 'invisibleDate'
                        : !isDayNotInRange(dateDetails.date)
                        ? 'jackpot-date-not-in-range'
                        : !dateDetails.visibility
                        ? 'invisibleDate'
                        : isCheckDate(dateDetails.date, prizeBreakdown?.checked_ticket_dates) && dateDetails.visibility
                        ? 'check-date-circle'
                        : ''
                    ">
                              @if (
                                isCheckDate(dateDetails.date, prizeBreakdown?.checked_ticket_dates) && dateDetails.visibility) {
                                <span (click)="openCheckedTickets(dateDetails, prizeBreakdown?.checked_ticket_dates)">
                                {{ dateDetails.date | date : "d" }}</span>
                              } @else {
                                {{ dateDetails.date | date : "d" }}
                              }
                            </h1>
                          }
                        </div>
                      }
                      @if (
                        isWinningDate(dateDetails.date, prizeBreakdown?.checked_ticket_dates) &&
                        dateDetails.visibility) {
                        <div class="animation">
                          <!--<app-thumb-animation></app-thumb-animation>-->
                        </div>
                      }
                      @if (
                        isWinningDateAnimation(dateDetails.date, prizeBreakdown?.checked_ticket_dates) &&
                        dateDetails.visibility && showAnimation
                        ) {
                        <div class="animation">
                          <app-thumb-animation></app-thumb-animation>
                        </div>
                      }
                      @if (
                        isCheckDate(dateDetails.date, prizeBreakdown?.checked_ticket_dates) &&
                        dateDetails.visibility &&
                        showAnimationForPoints
                        ) {
                        <div class="animation">
                          <!-- <app-thumb-animation></app-thumb-animation>-->
                        </div>
                      }
                      @if (
                        isCheckDateAnimation(dateDetails.date, prizeBreakdown?.checked_ticket_dates) &&
                        dateDetails.visibility &&
                        showAnimationForPoints
                        ) {
                        <div class="animation">
                          <app-thumb-animation></app-thumb-animation>
                        </div>
                      }
                    </ion-col>
                  }
                </ion-row>
              }
              @if (isEndDateSaturday()) {
                <div>
                  @for (dates of lastWeek; track dates) {
                    <ion-row class="rows-of-calender end-date-saturday">
                      @for (dateNumber of dates; track dateNumber) {
                        <ion-col class="ion-no-padding">
                          <div>
                            @if (dateNumber.visibility) {
                              <h1 class="day-date-numbers jackpot-date-not-in-range"
                                [ngClass]="isAfterNextSunday(dateNumber) ? 'in-range-number' : ''">
                                {{ dateNumber | date : "d" }}
                              </h1>
                            }
                          </div>
                        </ion-col>
                      }
                    </ion-row>
                  }
                </div>
              }
            </ion-grid>
          </div>
        </ion-row>
      </ion-grid>
      <div>
        <ion-grid class="ion-no-padding">
          <ion-row>
            <!--Cards Slider Start-->
            @if (getAllSlides()?.length) {
              <swiper [config]="storeSliderOptions" class="store-slider" #storePageCardSlider (swiper)="setSwiperInstance($event)">
                @for (banner of getAllSlides(); track banner) {
                    @if (banner?.card_type == 'promo_card' && bannerDisplayToggle() && isBannerDisplay()) {
                      <!-- Promo Card Slide -->
                      <ng-template swiperSlide>
                        <div class="store-card breakdown-card retool-card-bg game-card" [style.background]="banner?.background">
                          <div class="overlay-2 single-overlay">
                            <!-- Adjusted column sizes -->
                            <div class="adjusted-column-sizes">
                              <div class="column-60">
                                <div class="card-description-content">
                                  <span class="title">{{ banner?.content[selectedLanguage]?.title }}</span>
                                  <span class="sub-title">
                                    {{
                                      banner?.content[selectedLanguage]?.custom_text
                                        ? banner.content[selectedLanguage].custom_text
                                        : banner?.slider_info?.jackpot_value && banner?.slider_info?.jackpot_value !== "[variable_reference]"
                                          ? currencySymbol + banner.slider_info.jackpot_value
                                          : banner?.content[selectedLanguage]?.subtitle
                                    }}
                                  </span>
                                  <span class="description" [innerHTML]="banner?.content[selectedLanguage]?.description || '&nbsp'"></span>
                                </div>
                                <ion-button class="card-cta cta-mobile-position" (click)="redirectToPromoURL(banner?.cta_url)">
                                  {{ banner?.content[selectedLanguage]?.cta_label }}
                                </ion-button>
                                
                              </div>
                              <div class="column-40">
                                <div [ngClass]="{ 'image-container': banner?.image_url }">
                                  @if (banner?.image_url) {
                                    <img alt="banner icon" class="product_image" [src]="banner?.image_url" />
                                  }
                                </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                    } @else if(banner?.type === 'points') {
                      <!-- Regular Banner Slide -->
                      <ng-template swiperSlide>
                        <div class="store-card breakdown-card retool-card-bg game-card" [ngStyle]="getBackgroundStyle(banner?.background || banner?.slide_info?.background)">
                          <div class="overlay-2 single-overlay">
                            <!-- Adjusted column sizes -->
                            <div class="adjusted-column-sizes">
                              <div class="column-60">
                                  <div class="card-price" *ngIf="banner?.top_prize">
                                    <div class="game-price">
                                      <span>{{ banner?.top_prize }}</span>
                                    </div>
                                  </div>
                                  <div class="card-description">
                                    {{banner?.content?.[selectedLanguage]?.description ||
                                      banner?.slider?.content?.[selectedLanguage]?.line_description}}
                                  </div>
                                <ion-button class="card-cta cta-mobile-position point-cta" (click)="redirectToPromoURL(banner?.cta_url); trackBannerClick(banner);">
                                  {{
                                  banner?.content?.[selectedLanguage]?.cta_label ||
                                  banner?.content?.[selectedLanguage]?.ctaText ||
                                  banner?.slider?.content?.[selectedLanguage]?.cta_description
                                }}
                                </ion-button>
                                
                              </div>
                              <div class="column-40">
                                <div [ngClass]="{ 'image-container': banner?.image_url }">
                                  @if (banner?.image_url) {
                                    <img alt="Banner icon" class="product_image" [src]="banner?.image_url" />
                                  }
                                </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                    } @else {
                      @if (banner?.type === 'credit' || banner?.type === 'voucher') {
                      <ng-template swiperSlide>
                        <div class="store-card breakdown-card retool-card-bg"
                             [ngStyle]="getBackgroundStyle(banner?.background || banner?.slider?.product_image)">
                             <!-- Voucher badge -->
                          <div *ngIf="banner?.type === 'voucher' && banner?.hasVoucherOverlay && isVoucherTypeGeneral()" class="voucher-badge">
                            {{banner?.voucherOverlayText}}
                          </div>
                          <div class="overlay-2 single-overlay">
                            <div class="adjusted-column-sizes">
                              <div class="column-60">
                                <div class="card-price">
                                  <div class="blue-price">
                                    <span *ngIf="banner?.type === 'credit'">
                                      {{ banner?.content?.title }}
                                    </span>
                                    @if(banner?.type === 'voucher') {
                                      <div class="carousel-timer-wrapper-combo">
                                        <app-new-count-down-timer class="remaining-time-slider"
                                        [end]="banner?.slide_info?.expiry_date?._seconds || banner?.slide_info?.expiry_date?.seconds" type="seconds"></app-new-count-down-timer>
                                      </div>
                                      <div class="discount-section desktop-view">
                                        @if (banner?.slide_info?.discount_value) {
                                        <span class="custom-combo-discount">{{banner?.slide_info?.discount_value}} {{'breakdown.off' |
                                          translate}}</span>
                                        }
                                      </div>
                                    }
                                    <span *ngIf="banner?.type === 'voucher'">
                                      <h5 class="voucher-product-title">{{ banner?.slider?.content?.[selectedLanguage]?.product_title || '' }}</h5>
                                      <span class="voucher-jackot-value">
                                        {{ currencySymbol }}{{
                                          banner?.slide_info?.jackpot_value?.[preferredCurrency] ||
                                          banner?.price
                                        }}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                      
                                <div class="card-description" *ngIf="banner?.type === 'credit'">
                                  {{ banner?.content?.[selectedLanguage]?.description || banner?.content?.description }}
                                </div>
                      
                                <ion-button class="card-cta cta-mobile-position"
                                            (click)="redirectToPromoURL(banner?.cta_url , banner?.slide_info?.jackpot_value?.[preferredCurrency],'voucher'); trackBannerClick(banner)">
                                  {{
                                    banner?.content?.[selectedLanguage]?.cta_label ||
                                    banner?.content?.[selectedLanguage]?.ctaText || banner?.content?.ctaText ||
                                    banner?.slider?.content?.[selectedLanguage]?.cta_description
                                  }}
                                </ion-button>
                              </div>
                      
                              <div class="column-40">
                                <div [ngClass]="{ 'image-container': banner?.image_url }">
                                  @if (banner?.image_url) {
                                    <img alt="Banner icon"
                                         class="product_image"
                                         [src]="banner.image_url" />
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                      }
                    }
                }
              </swiper>
            }
              <!--Cards Slider End-->
            </ion-row>
          </ion-grid>
        </div>
        <p class="back-to-syndicate" (click)="backTpSyndicate()">←{{ "breakdown.Back" | translate }}</p>
      </div>
    </ion-content>
  } @else {
    <app-in-progress-animation></app-in-progress-animation>
  }

  @if (user$ | async) {
  }
